import { Checkbox, Label } from 'keep-react'

export const FormCheckbox = ({
  formik,
  name,
  label,
}: {
  name: string
  label: string
  formik: any
}) => {
  const { error, value } = formik.getFieldMeta(name)

  return (
    <div>
      <fieldset className="flex items-center gap-2">
        <Checkbox
          color="primary"
          defaultChecked={value ? true : false}
          id={name}
          name={name}
          onCheckedChange={() => formik.setFieldValue(name, !value)}
        />
        <Label className="text-body-4 block" htmlFor={name}>
          {label}
        </Label>
      </fieldset>

      {error && (
        <span className="py-2 block w-full text-body-5 text-error-600">
          {error}
        </span>
      )}
    </div>
  )
}
